export const listAccountApplications = `
   query listAccountApplications($filter:AccountApplicationsFilterInput, $limit: Int, $nextToken: String) {
       listAccountApplications(filter:$filter, limit:$limit, nextToken:$nextToken) {
           items {
              id
              accountId
              account {
                  id
                  username
              }
              applicationId
              application {
                  id 
                  name
              }
              accountApplicationStatus
              created
              updated
           }
           nextToken
       }
   }
`;


export const getAccountApplication = `
   query getAccountApplication($id:ID!) {
       getAccountApplication(id:$id) {
         id
         accountId
         applicationId
         application {
             id 
             name
         }
         accountApplicationStatus
         created
         updated
       } 
}`;
